// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';

// Components
import { TableCard, CardHeader } from 'components/content-containers/cards';
import PurchaseOrderForm from 'components/models/purchases/forms/purchase-order-form';


// Component
class AddPurchaseOrder extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    ticket: PropTypes.object,
    onCreate: PropTypes.func
  };

  constructor() {
    super();
    this.createPurchaseOrder = this.createPurchaseOrder.bind(this);
  }

  createPurchaseOrder(values) {
    const formattedValues = _.cloneDeep(values);
    delete formattedValues.company;
    formattedValues.createdBy = formattedValues.purchasedBy;
    _.remove(formattedValues.lineItems, (lineItem) => _.every(lineItem, _.isEmpty));

    PurchaseOrder.create(formattedValues)
      .then(this.props.onCreate)
      .catch(alerts.catchError);
  }

  render() {
    const { currentUser, ticket } = this.props;

    return (
      <TableCard className="purchase-card">
        <CardHeader>Add Purchase Order</CardHeader>
        <PurchaseOrderForm
          initialValues={{
            lineItems: [{}],
            purchasedBy: currentUser.id,
            date: moment().toDate(),
            ticket: _.get(ticket, 'id'),
            company: _.get(ticket, 'agreement.company')
          }}
          form={'purchaseOrderForm-new'}
          onSubmit={this.createPurchaseOrder}
          autoFocusField={_.isEmpty(ticket) ? 'company' : 'vendor'}
        />
      </TableCard>
    );
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(AddPurchaseOrder);
